<template>
    <div>
        <RemoteTable ref="table" :form="form" :table="table">
            <template #expand="{row}">
                <dl class="dl-horizontal">
                    <dt>名单预览</dt>
                    <dd style="overflow-wrap: break-word">{{row.preview}}</dd>
                </dl>
            </template>
            <template #default="{row, property}">
                <template v-if="property === 'code'">
                    {{$root.getBusinessName(row.code)}}
                </template>
            </template>
        </RemoteTable>
    </div>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {name: "code", label: "业务", type: "cascade", op: "beginwith", value: ""},
                        {name: "name", label: "名称", type: "input", op: "contains", value: ""},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.$router.push("/namelist/0")
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/namelist",
                    expand: true,
                    defaultSort: {prop: 'createTime', order: 'descending'},
                    columns: [
                        {label: "业务名称", name: "code"},
                        {label: "名称", name: "name", width: 200},
                        {label: "手机号码数", name: "totalNum", width: 120},
                        {label: "错误数", name: "errorNum", width: 80},
                        {label: "创建时间", name: "createTime", width: 150, sortable: true},
                    ],
                    tools: []
                }
            }
        },
    }
</script>